<template>
  <div class="controlEditor">
    <div class="controlModule">
      <div class="innerTitle">
        {{locale.property}}
        <!-- 편집모드 -->
        <div class="typeMode">
          <span class="typeItem">
            <input type="radio" name="typeMode" id="typeMode_edit" value="edit" v-model="typeMode">
            <label for="typeMode_edit"></label>
          </span>
          <span class="typeItem">
            <input type="radio" name="typeMode" id="typeMode_view" value="view" v-model="typeMode">
            <label for="typeMode_view"></label>
          </span>
        </div>
        <!-- //편집모드 -->
      </div>
      <!-- 프로퍼티 -->
      <div class="controlTypes" :data-mode="typeMode">
        <!-- 제어모듈 리스트 -->
        <div class="list">
          <div class="item"
            v-for="(type, index) in types"
            :key="`type_${index}`"
            :data-mods_type="type.type">
            <!-- 최상위 제어타입 -->
            <!-- 모드:: 보기 -->
            <div v-if="typeMode === 'view'" class="viewModeItem">
              <span>{{type.type}}</span>
            </div>
            <!-- //모드:: 보기 -->
            <!-- 모드:: 편집 -->
            <div v-else class="innerWrapper parent">
              <div class="addChild">
                <input
                  type="text"
                  class="input"
                  :disabled="type.fixed"
                  v-model="type.type"
                  @keyup.enter="addChild(type.type)">
                <button type="button" class="btnAdd" @click="addChild(type.type)">+</button>
              </div>
              <button v-if="!rcu.includes(type.type)" type="button" class="btnDel" @click="deleteProperty(type.type)"></button>
              <!-- <button type="button" class="btnSetting" @click="setTypeSetting(type)"><span class="blind">setting</span></button> -->
            </div>
            <!-- //모드:: 편집 -->
            <!-- //최상위 제어타입 -->
            <!-- 제어타입 프로퍼티 -->
            <draggable
              class="children"
              :list="type.children"
              :group="{ name: 'moduleGroup', pull: 'clone', put: false }"
              :sort="false"
              :clone="onClone"
              :options="{filter: '.disabled', preventOnFilter: false}">
              <div class="childrenItem"
                v-for="(children, idx) in type.children"
                :key="`type_children_${idx}`"
                :data-extra="children.extra ? children.index : null"
                :class="{disabled: disabledModule(children, idx)}">
                <!-- 모드:: 보기 -->
                <div v-if="typeMode === 'view'" class="viewModeItem" :class="{ghost: children.extra}">
                  <span>{{children.extra ? `${children.type} ${children.index}` : `${children.index}: ${children.location}`}}</span>
                </div>
                <!-- //모드:: 보기 -->
                <!-- 모드:: 편집 -->
                <div v-else>
                  <div v-if="children.extra && children.index === 'all'" class="itemWrapper">{{locale.roomcontrol_all}}</div>
                  <div v-else-if="children.extra && children.index === 'multi'" class="itemWrapper">{{locale.roomcontrol_multi}}</div>
                  <div v-else class="itemWrapper">
                    <button type="button" class="btnDel" @click="deleteChildren(children, idx)"></button>
                    <div class="innerWrapper">
                      <div><span class="label">{{locale.index}}</span></div>
                      <input type="text" class="input" v-model="children.index">
                    </div>
                    <div class="innerWrapper">
                      <div><span class="label">{{locale.location}}</span></div>
                      <input type="text" class="input" v-model="children.location">
                    </div>
                  </div>
                </div>
                <!-- //모드:: 편집 -->
                <!-- disabled module -->
                <p v-if="disabledModule(children, idx)" class="disabledMessage">{{disabledModule(children, idx)}}</p>
                <!-- //disabled module -->
              </div>
            </draggable>
            <!-- //제어타입 프로퍼티 -->
          </div>
        </div>
        <button v-if="typeMode === 'edit'" type="button" class="btn btnWhite btnFull" @click="addType">{{locale.add_property}}</button>
      </div>
      <!-- //프로퍼티 -->
    </div>
    <div class="controlPreview preview" @click="onDocumentClick">
      <div id="article" class="article roomControl">
        <p class="innerTitle">{{locale.roomcontrol_edit}}</p>
        <div class="modsWrap" :data-view="controlInfo.viewtype">
          <draggable
            class="modsGroup"
            v-model="typeGroup"
            :animation="200"
            :options="{draggable: '.groupBox'}"
            handle=".handleGroup .handleMove">
            <div class="groupBox"
              v-for="(group, index) in typeGroup"
              :key="`${group.id}_${index}`"
              :class="{active: group.id === (activeGroup && activeGroup.id)}"
              :data-view="group.viewtype || 'list'"
               @click="onGroupClick($event, group)">
              <!-- <div v-if="!(activeGroup && group.id === activeGroup.id)" class="setGroup" @click="onGroupClick($event, group)"></div> -->
              <div class="handleGroup">
                <button type="button" class="handle handleMove" title="move"></button>
                <button type="button" class="handle handleDel" @click="onRemove($event, index)" title="remove"></button>
              </div>
              <div class="groupLabel">
                <input type="text" class="input" v-model="group.label[lang]" />
              </div>
              <draggable class="group"
                v-model="typeGroup.find(x => x.id === group.id).list"
                :animation="200"
                :options="{draggable: '.mods'}"
                :style="{justifyContent: group.viewtypeAlign}"
                group="moduleGroup">
                <div class="mods"
                  v-for="(mods, index) in typeGroup.find(x => x.id === group.id).list"
                  :key="`${mods.id}_${index}`"
                  :class="{isFull: mods.detail.type === 'fcu' && (mods.detail.control === 'temp' || mods.detail.control === 'speed')}"
                  @mouseenter="onMouseEnter"
                  @mouseleave="onMouseLeave"
                  @click="onModuleClick($event, group.id, mods)">
                  <button type="button" class="btnDel" @click="onRemoveModule($event, group.id, index)"></button>
                  <ControlModule
                    :locale="locale"
                    :lang="lang"
                    :module="mods"
                    :controlList="controlList"
                    @updateLabel="updateLabel" />
                </div>
              </draggable>
              </div>
          </draggable>
          <button type="button" class="btn btnFull mt15" @click="btnAddControlGroup">+ {{locale.add_roomcontrol_group}}</button>
        </div>
        <span class="previewOnly">{{locale.editor_preview_area}}</span>
      </div>
    </div>
    <div class="controlModuleSetting moduleSetting">
      <p class="innerTitle">{{locale.roomcontrol_setting}}</p>
      <SettingModule v-if="active || activeGroup"
        :locale="locale"
        :typeInfo="active"
        :groupInfo="activeGroup"
        :typeParent="activeType"
        @updateDetail="updateDetail" />
    </div>
  </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'
import draggable from 'vuedraggable'
import ControlModule from './Module.vue'
import SettingModule from './SettingModule.vue'

export default {
  props: [
    'locale',
    'lang',
    'spacetypeNames',
    'subtypeNames',
    'controlInfo',
    'moduleData',
    'controlData',
    'saveTimeStamp',
    'rcu'
  ],
  components: {
    draggable,
    ControlModule,
    SettingModule
  },
  computed: {
    langValue () {
      const langValue = this.$store.getters['setting/getData'].lang.langValue
      return this._.cloneDeep(langValue)
    },
    controlList () {
      const types = this.types
      let typeList = []
      let locationList = []
      let indexList = []
      for (let i = 0; i < types.length; i++) {
        const type = types[i]
        typeList.push(type.type)
        for (let j = 0; j < type.children.length; j++) {
          const item = type.children[j]
          if (!item.extra) {
            locationList.push(item.location)
            indexList.push(item.index)
          }
        }
      }
      return {
        type: typeList,
        location: locationList,
        index: indexList
      }
    }
  },
  watch: {
    saveTimeStamp () {
      this.saveItem()
    },
    moduleData (data) {
      this.typeGroup = data
    },
    controlData (data) {
      if (data.length) {
        this.types = data.map(x => {
          let extra = []
          if (x.type === 'light' || x.type === 'curtain') {
            extra.push(this.addExtra(x.type).all)
            extra.push(this.addExtra(x.type).multi)
          } else if (x.type === 'fcu') {
            extra.push(this.addExtra(x.type).all)
          }
          return {
            ...x,
            fixed: this.rcu.includes(x.type),
            children: extra.concat(x.children)
          }
        }).sort((a, b) => {
          return this.rcu.includes(b.type) - this.rcu.includes(a.type)
        })
      } else {
        return []
      }
    },
    active: {
      deep: true,
      handler (data) {
        if (data) {
          const group = this.typeGroup.find(x => x.id === data.group)
          const module = group.list.find(x => x.id === data.id)
          module.detail = data.detail
          module.multi = data.multi
          module.multiOnoff = data.multiOnoff
        }
      }
    }
  },
  mounted () {
  },
  data () {
    return {
      initType: {
        type: 'newtype',
        viewtype: 'list',
        children: []
      },
      initTypeChild: {
        type: '',
        index: '',
        location: 'location',
        label: {}
      },
      initAllChild: {
        extra: true,
        type: '',
        index: 'all',
        location: 'all',
        label: {}
      },
      initMultiChild: {
        extra: true,
        type: '',
        index: 'multi',
        location: 'multi',
        multi: [],
        multiOnoff: [],
        label: {}
      },
      typeMode: 'edit', // type: edit, view
      types: [
        {
          type: 'light',
          viewtype: 'grid',
          fixed: true,
          children: []
        },
        {
          type: 'fcu',
          viewtype: 'list',
          fixed: true,
          children: []
        },
        {
          type: 'dm',
          viewtype: 'grid',
          fixed: true,
          children: []
        },
        {
          type: 'curtain',
          viewtype: 'list',
          fixed: true,
          children: []
        }
      ],
      typeGroup: [],
      moduleList: [],
      active: null,
      activeGroup: null,
      activeType: null
    }
  },
  methods: {
    addType () {
      const init = this._.cloneDeep(this.initType)
      const type = init.type
      const length = this.types.length + 1
      init.type = `${type}${length}`
      this.types.push(init)
    },
    addExtra (type) {
      const all = this._.cloneDeep(this.initAllChild)
      const multi = this._.cloneDeep(this.initMultiChild)
      const langValue = this.langValue
      all.type = type
      all.label = UTIL.fillLangs(langValue, '')
      multi.type = type
      multi.label = UTIL.fillLangs(langValue, '')
      return {
        all: all,
        multi: multi
      }
    },
    addChild (type) {
      const init = this._.cloneDeep(this.initTypeChild)
      const property = this.types.find(x => x.type === type)
      const length = property.children.filter(x => !x.extra).length + 1
      const langValue = this.langValue
      const dmIndex = length === 1 ? 'dnd' : length === 2 ? 'mur' : `${type}${length}`
      if (!property.children.length) {
        const extra = this.addExtra(type)
        if (type === 'light' || type === 'curtain') {
          property.children.unshift(extra.all)
          property.children.unshift(extra.multi)
        } else if (type === 'fcu') {
          property.children.unshift(extra.all)
        }
      }
      init.type = type
      init.index = type === 'dm' ? dmIndex : `${type}${length}`
      init.label = UTIL.fillLangs(langValue, '')
      property.children.push(init)
    },
    deleteProperty (type) {
      if (window.confirm(this.locale.confirm_delete_property)) {
        this.types = this.types.filter(x => x.type !== type)
      }
    },
    deleteChildren (children, index) {
      if (window.confirm(this.locale.confirm_delete_property)) {
        const type = this.types.find(x => x.type === children.type)
        type.children = type.children.filter((x, i) => i !== index)
      }
    },
    disabledModule (item, idx) {
      let result
      const children = this.types.find(x => x.type === item.type).children.find((c, i) => i === idx)
      const index = getStr(item.index)
      const location = getStr(item.location)
      const childrenIdx = this.types.find(x => x.type === item.type).children
        .filter((c, id) => (id !== idx) && !c.extra)
        .map(s => getStr(s.index))
      function getStr (str) {
        return regExp.replaceAllEmpty(str).toLowerCase()
      }
      if (!item.extra) {
        // 사용할 수 없는 인덱스입니다.
        if (index === 'all' || index === 'multi') {
          result = this.locale.message_invalid_index
        // 동일한 인덱스가 존재합니다.
        } else if (childrenIdx.includes(index)) {
          const origin = this.types.find(x => x.type === item.type).children.map(s => getStr(s.index)).indexOf(index)
          if (idx > origin) {
            result = this.locale.message_exist_index
          }
        // 인덱스를 반드시 입력해주세요.
        } else if (!index.length) {
          result = this.locale.message_empty_index
        } else if (!location.length) {
          result = this.locale.message_empty_location
        }
      }
      if (result) {
        item.invalid = true
      } else {
        delete item.invalid
      }
      return result
    },
    btnAddControlGroup () {
      const length = this.typeGroup.length + 1
      const langValue = this.langValue
      this.typeGroup.push({
        id: UNIQUE.mid(),
        label: UTIL.fillLangs(langValue, `group${length}`),
        list: [],
        viewtype: 'list',
        viewtypeAlign: 'left'
      })
    },
    updateDetail (data) {
      this.active.detail = data
    },
    onClone (data) {
      const cloneData = this._.cloneDeep(data)
      const langValue = this.langValue
      cloneData.id = UNIQUE.mid()
      cloneData.label = UTIL.fillLangs(langValue, data.location)
      cloneData.detail = {
        type: cloneData.type,
        icon: `${cloneData.type}_1`,
        control: 'toggle'
      }
      return cloneData
    },
    onRemove: function (e, index) {
      e.stopPropagation()
      if (confirm(this.locale.confirm_delete_roomcontrol_group)) {
        this.typeGroup.splice(index, 1)
      }
    },
    onRemoveModule: function (e, groupId, index) {
      e.stopPropagation()
      if (confirm(this.locale.confirm_delete_roomcontrol_module)) {
        this.typeGroup.find(x => x.id === groupId).list.splice(index, 1)
      }
    },
    onMouseEnter: function (e) {
      e.target.classList.add('hover')
    },
    onMouseLeave: function (e) {
      e.target.classList.remove('hover')
    },
    /**
     * 특정 엘리먼트에 클래스명을 추가하고 인접 엘리먼트들에 클래스명을 삭제
     * @param target 클래스 추가할 대상, DOM object (* array 아님 주의)
     * @param classname 추가/삭제할 클래스명, string
     * @param classaction add or remove 단일 실행
     */
    addRemoveClass: function (target, classname, classaction) {
      if (classaction !== 'add') {
        [...target.parentElement.children].forEach(el => el.classList.remove(classname))
      }
      if (classaction !== 'remove') {
        target.classList.add(classname)
      }
    },
    onModuleClick: function (e, group, data) {
      e.stopPropagation()
      let target = e.currentTarget
      const groupBox = document.querySelectorAll('.groupBox')
      const mods = document.querySelectorAll('.mods')
      if (groupBox !== null) {
        groupBox.forEach(el => el.classList.remove('active'))
      }
      this.activeGroup = null
      if (mods !== null) {
        mods.forEach(el => el.classList.remove('active'))
      }
      if (e.target.closest('.mods') !== null && e.target.closest('.mods').className.indexOf('active') === -1) {
        this.addRemoveClass(target, 'active')
        this.active = {
          ...data,
          group: group,
          detail: data.detail || {
            type: data.type,
            icon: `${data.type}_1`
          }
        }
        this.activeType = this.types.find(x => x.type === data.type)
      }
    },
    onGroupClick: function (e, group) {
      e.stopPropagation()
      let target = e.currentTarget
      const mods = document.querySelectorAll('.mods')
      if (mods !== null) {
        mods.forEach(el => el.classList.remove('active'))
      }
      this.active = null
      if (e.target.closest('.groupBox') !== null && e.target.closest('.groupBox').className.indexOf('active') === -1) {
        this.addRemoveClass(target, 'active')
        this.activeGroup = group
      }
    },
    onDocumentClick: function (e) {
      if (e.target.closest('.article') === null && e.target.closest('.handleMods') === null) {
        const mods = document.querySelectorAll('.mods')
        const group = document.querySelectorAll('.groupBox')
        if (group !== null) {
          group.forEach(el => el.classList.remove('active'))
        }
        if (mods !== null) {
          mods.forEach(el => el.classList.remove('active'))
        }
        this.active = null
        this.activeGroup = null
        this.activeType = null
      }
    },
    updateLabel (data) {
      const lang = this.lang
      function findLabel (arr, id) {
        return arr.find(x => x.id === id)
      }
      this.typeGroup.forEach(function (x) {
        if (findLabel(x.list, data.id)) {
          findLabel(x.list, data.id).label[lang] = data.label
        }
      })
    },
    typeToProperty () {
      const types = this.types
      const property = arrayToObj(types)
      const propertyDefault = {
        lightMask: {
          f1: 255,
          f2: 255,
          f3: 255
        }
      }
      const subtype = [...new Set(this.subtypeNames.concat(this.controlInfo.subtype))]
      function getProperty (arr) {
        let result = {}
        arr.forEach(c => {
          if (!c.extra && !c.invalid) {
            result[c.index] = c.location
          }
        })
        return result
      }
      function arrayToObj (arr) {
        let result = {}
        arr.forEach(x => {
          const type = x.type
          const count = `${type}count`
          result[type] = getProperty(x.children)
          result[count] = x.children.filter(x => !x.extra && !x.invalid).length.toString()
        })
        return result
      }
      return { ...property, ...propertyDefault, subtype: subtype }
    },
    validateOnSave () {
      /**
       * 중복 spacetype
       * 빈 spacetype
       * 중복 인덱싱
       * 빈 인덱싱
       */
      const isNew = this.$route.name === 'controlNewItem'
      const spacetypeBefore = this.$route.params.id
      const spacetype = this.controlInfo.spacetype
      const spacetypeNames = this.spacetypeNames
      if (!spacetype.length) {
        alert(this.locale.validate_empty_spacetype)
        return false
      } else if (spacetype !== spacetypeBefore && spacetypeNames.includes(spacetype)) {
        alert(this.locale.validate_exist_spacetype)
        return false
      } else if (!isNew && spacetype !== spacetypeBefore) {
        return window.confirm(this.locale.confirm_save_new_spacetype)
      } else {
        return true
      }
    },
    saveItem () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const spacetype = this.controlInfo.spacetype
        const subtype = this.controlInfo.subtype
        const property = this.typeToProperty()
        const module = this.typeGroup
        const info = this.controlInfo
        const controlData = { spacetype: spacetype, data: property }
        const moduleData = { spacetype: spacetype, subtype: subtype, data: { info: info, list: module } }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('control/updateControl', controlData).then((res) => {
          this.$store.dispatch('control/setSpaceType', moduleData).then((res) => {
            alert(this.locale.complete_save)
            this.$store.commit('onLoading', false)
            this.$router.replace({ name: 'controlItem', params: { id: spacetype, subtype: subtype } })
            this.$emit('init')
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.innerTitle {
  position: relative;
  margin-bottom: 0;
  padding: 15px;
  font-weight: bold;
  border-bottom: 1px solid $color-lgrey2;
}
</style>
